import React from 'react';

import RIQDropdown from '../../../components/RIQDropdown.jsx';

import {
    useCurationConfigValue
} from '../../../hooks/widgetConfiguration.js';

import {
    listeningDefinitions
} from './enums/listeningDefinitions.jsx';

const {
    disabledTooltip
} = listeningDefinitions['toolbar-dropdown'];

export default function LanguageDropdown({defaultLanguage, onLanguageSelected, isInstantSearch, trackingId}) {

    /** defaultLanguage is the entrance language, from the saved topic or the browser.
        language is the one chosen from the dropdown. either from an unedited instant search, or an instant search or saved topic with 'All' selected.
        selectedLanguage is what is chosen in the wizard. if it's in a topic, it's the selected language and the default.
        if it's an edited instant search, selectedLanguage trumps the defaultLanguage or language had been chosen from an unedited instant search. */

    let language = useCurationConfigValue('language');
    const selectedLanguage = useCurationConfigValue('selectedLanguage');
    if (defaultLanguage) {
        language = defaultLanguage;
    }
    if (selectedLanguage) {
        language = selectedLanguage;
    }

    const languageOptions = _(RivalIQ.metrics.new.enums.ListeningLanguages)
        .values()
        .map(listeningLanguage => {
            return {
                id: listeningLanguage.id,
                selected: listeningLanguage.id === language,
                name: listeningLanguage.name
            };
        })
        .sortBy('name')
        .value();
    languageOptions.unshift({
        id: 'all',
        selected: !language,
        name: 'All'
    });

    function onItemSelected(language) {
        onLanguageSelected(language.id === 'all' ? null : language.id);
    }

    const isDisabled = (!isInstantSearch && Boolean(defaultLanguage)) || Boolean(selectedLanguage);

    return (
        <RIQDropdown
            variant='toolbar'
            title='Language'
            showSelectedInTitle={true}
            dropdownOptions={languageOptions}
            onItemSelected={onItemSelected}
            isDisabled={isDisabled}
            activeFilter={Boolean(language)}
            tooltipText={disabledTooltip(`search`, `language`)}
            trackingId={trackingId}
        />
    );
}
